import { render } from "./notificationsPipeline.vue?vue&type=template&id=2c9703ca"
import script from "./notificationsPipeline.vue?vue&type=script&lang=js"
export * from "./notificationsPipeline.vue?vue&type=script&lang=js"

import "./notificationsPipeline.vue?vue&type=style&index=0&id=2c9703ca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__